<template lang="pug">
extends ../../../prototype/src/pug/layout/section_column_gray
include ../../../prototype/src/pug/abstracts/mixin.pug
block main
	.atendimento_online__wrapper
		h1.atendimento_online__title Atendimento online

		p.atendimento_online__description Para iniciar seu atendimento, por favor, preencha os campos abaixo.

		form.atendimento_online__form
			legend.atendimento_online__legend Todos os campos são obrigatórios
			+field_text("Seu nome", "nome", "Ex.: Paulo Silva", "name_1")
			+field_cpf_required("Seu CPF", "cpf", "Digite apenas números", "cpf_1")
			+field_email("Seu e-mail", "email", "Ex.: paulo.silva@mail.com.br", "email_1")

		.atendimento_online__actions
			a(href="#").button Enviar
block variables
	- var id = 'atendimento'			
</template>

<script>
export default {
	name: "Atendimento"
}
</script>